module.exports = __webpack_public_path__ + "static/media/oxy-froot.9337a038.pdf";